export const ru = {
  clipboard: {
    successCopied: "Скопировано в буфер обмена",
  },
  notification: {
    title: "Настройки уведомлений",
    emailNotifications: "Уведомления по электронной почте",
    marketingEmails: "Маркетинговые рассылки"
  },
  safety: {
    title: "KYC Верификация",
    subtitle: "Пройдите верификацию для доступа ко всем функциям платформы.",
    bannerTitle: "Верификация через Reown",
    bannerText1: "Ваш аккаунт использует аутентификацию Reown.",
    bannerText2: "Для повышения уровня верификации перейдите в раздел \"Верификация\".",
    standardLevel: "Стандартный уровень",
    standardDesc: "Подтверждение электронной почты и номера телефона.",
    enhancedLevel: "Расширенный уровень",
    enhancedDesc: "Предоставление паспортных данных.",
    professionalLevel: "Профессиональный уровень",
    professionalDesc: "Подтверждение адреса проживания.",
    completed: "Выполнено",
    inProgress: "В процессе",
    start: "Начать"
  },
  referral: {
    title: "Реферальная программа",
    description: "Приглашайте друзей и получайте награды!",
    subtitle: "Ваша реферальная ссылка",
    yourReferrals: "Ваши рефералы",
    statsElements: ["Всего рефералов", "Активных", "Объем инвестиций", "Ваш доход"],
    yourLevel: {
      topTitle: "Ваш уровень",
      toNextLevel: "До следующего уровня:",
      activeReferralsOr: "активных рефералов или ",
      toLvl: "до уровня"
    },
    referrer: {
      title: "Есть реферальный код? Введите его здесь",
      enterCode: "Введите код",
      check: "Проверить"
    },
    confirm: "Подтвердить",
    changeRefCode: "Изменить реферальный код",
    newCode: "новый код",
    enterNewCode: "Введите новый код",
    minMaxChars: "Минимум 6 символов, максимум 8"
  },
  referralNew: {
    code: {
      title: 'Eсть реферальный код?',
      description: 'Введите его ниже,\nчтобы связаться с партнёром.',
      input: 'Реферальный код',
      button: 'Проверить',
      title_CodeVerified: 'Код принят!',
      description_CodeVerified: 'Теперь можете приглашать других и получать бонусы',
      youInviter: 'ваш реферер'
    },
    details: {
      title: 'Ваши реферальные данные',
      description: 'Приглашайте друзей в Zenex и зарабатывайте бонусы.',
      sendThis: 'Отправьте ссылку другу',
      orShare: 'Или передайте код для ручного ввода',
      members: 'участников',
      paidOut: 'выплачено за 2025 год',
      alreadyEarning: 'уже зарабатывают\n с нами'
    },
    program: {
      button: "Узнать больше",
      cards: {
        title: "ЕЖЕМЕСЯЧНЫЕ РАНГИ",
        subtitle: "Реферальная система",
        description: "Зарабатывайте на обороте карт",
        how: "Как это работает",
        elements: [
          "Считается объём\nпополнений\nрефералов",
          "Статус\nпересчитывается\n1-го числа месяца",
          "Комиссия\nвыплачивается по\nтекущему уровню"
        ]
      },
      invest: {
        title: "НАКОПИТЕЛЬНАЯ СИСТЕМА",
        subtitle: "Партнёрская программа",
        description: "Зарабатывайте на инвестициях друзей",
        how: "Как зарабатывать",
        elements: [
          "Пригласите друга\nв систему Zenex\nInvest",
          "Он начинает\nинвестировать\nв пулы Zenex",
          "Вы получаете\nбонусы с его\nприбыли"
        ]
      }
    }
  },
  innerReferral: {
    title: "Реферальная система \n Zenex Invest",
    statistic: {
      pattern: " в этом месяце",
      status: {
        title: "Текущий статус",
        subtitle: "Ваши бонусы: ",
        description: "{depositBonus} от депозита и {incomeBonus} от прибыли",
        labelLeft: "До {level}",
        labelCenter: "{count, plural, one {# реферал} few {# реферала} many {# рефералов} other {# реферала}} или",
        labelRight: ""
      },
      referrals: {
        title: "Активные рефералы",
        description: "+{count} новых",
      },
      deposit: {
        title: "Общая сумма депозитов",
        description: "+{count}$"
      },
      income: {
        title: "Мой доход",
        description: "~{count}$",
        pattern: "/в месяц",
      },
    },
    link: {
      title: "Повысьте свой статус и зарабатывате больше",
      sendThis: 'Отправьте ссылку другу',
      orShare: 'Или передайте код для ручного ввода',
    },
    tabs: {
      levels: "Система уровней",
      history: "История выплат",
      referrals: "Список рефералов",
    },
    faq: {
      kicker: "FAQ",
      title: "Как работает реферальная система",
      questions: [
        "Куда зачисляются мои реферальные вознаграждения и как я могу их вывести?",
          "Реферальная ссылка отличается для каждого продукта или есть одна и та же ссылка?",
          "Я пригласил друга, и он инвестировал в пул RevShare. Когда я получу свое вознаграждение?",
          "Как я могу повысить свой уровень в реферальной программе?",
      ],
      answers: [
        "Ваши реферальные вознаграждения зачисляются непосредственно на кошелек, подключенный к вашей учетной записи Zenex Hub, и вы можете вывести их на любой внешний крипто-кошелек.",
        "Для всех продуктов Zenex существует единая реферальная ссылка. Поделившись одной ссылкой, вы получаете вознаграждение за каждый продукт, который использует ваш реферал.",
        "Реферальные вознаграждения начисляются начиная со следующего месяца. Вы получаете как часть их депозита (единовременное вознаграждение), так и часть их прибыли (повторяющиеся ежемесячные вознаграждения).",
        "Ваш уровень повышается, как только общий объем инвестиций ваших рефералов достигает уровня, необходимого для перехода на следующий уровень. Новый уровень применяется в начале следующего календарного месяца.",
      ],
    },
    levels: {
      title: "Система уровней и наград",
      description: "Уровень определяется по лучшему показателю: количеству активных рефералов или сумме их инвестиций",
      status: {
        received: "Получен",
        current: "Текущий уровень",
        blocked: "Заблокировано",
        more: "Еще {count, plural, one {# реферал} few {# реферала} many {# рефералов} other {# реферала}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Рефералы",
        total: "Общая сумма депозитов",
        incomeDeposit: "Доход от депозита",
        incomeStable: "Доход от депозита Stable Pool",
        incomeGrowth: "Доход от прибыли Growth Pool",
      },
    },
    filters: {
      label: "Сортировать по",
      dateAscending: "Дата: по возрастанию",
      dateDescending: "Дата: по убыванию",
      incomeAscending: "Доход: по возрастанию",
      incomeDescending: "Доход: по убыванию",
    },
    pagination: "Страница {current} из {total}",
    incomeHistory: {
      title: "Доход и история выплат",
      column: {
        date: "Дата",
        user: "Реферал",
        pool: "Pool",
        incomePercent: "Прибыль",
        income: "Сумма",
      },
    },
    referrals: {
      title: "Мои рефералы",
      column: {
          user: "Реферал",
          pool: "Pool",
        deposit: "Инвест",
        profit: "Прибыль реферала",
        earning: "Мой доход",
      },
    },
  },
  quest: {
    title: "Задачи и достижения",
    subtitle: "Выполняйте задания, чтобы получать бонусы и награды!",
    subscribe: "Подпишитесь на наш Instagram!",
    follow: "Подпишитесь на нас в X!",
    join: "Присоединяйтесь к нашему Telegram!",
    done: "Готово",
    complete: "Выполнить"
  },
  account: {
    title: "Аккаунт",
    fields: {
      name: "Имя",
      nickname: "Никнейм",
      email: "Email",
      bio: "О себе"
    },
    verify: "Подтвердить",
    confirmChanges: "Сохранить изменения",
    updateSuccess: "Изменения успешно сохранены",
    updateError: "Не удалось сохранить изменения",
    linksTitle: "Привяжите аккаунты для дополнительных возможностей",
    connectX: "Подключить X",
    connectTelegram: "Подключить Telegram",
    connectInstagram: "Подключить Instagram",
    logout: "Выйти",
    emailDialog: {
      title: "Подтвердите вашу почту",
      description1: "Мы отправили 6-значный код на {email}",
      description2: "Введите его ниже, чтобы завершить регистрацию и получить доступ ко всем функциям Zenex Hub.",
      confirmBtn: "Подтвердить почту",
      cantFind: "Не нашли письмо? Проверьте папку Спам",
      resend: "или запросите новое",
      sentPrefix: "Мы отправили 6-значный код на"
    },
    cancel: "Отмена",
    saveChanges: "Сохранить изменения",
    selectNewAvatar: "Выбрать новый аватар",
    unsavedChanges: {
      title: "Несохранённые изменения",
      subtitle: "У вас есть несохранённые изменения. Отменить их и выйти?"
    }
  },
  sell: {
    to: "Куда вывести",
    select: "выберите токен",
    button: "Вывести",
    loading: "Вывод…"
  },
  errors: {
    insufficientFunds: "Недостаточно средств",
    maxLimit: "Максимальный лимит — {value}$",
    serviceUnavailable: "Сервис недоступен, попробуйте позже",
  },
  card: {
    title: {
      white: "— Новая эра карточных платежей начинается здесь!",
      green: "от Zenex",
      yellow: "NS.Cards"
    },
    description:
      "0 комиссий за транзакции, ограничения по МСС, расходы до $100 000 — все это и многое другое в карте Zenex.",
    button: "Заказать карту",
    columns: {
      left: {
        title: {
          white: "NS.Cards для",
          green: "медиабаеров"
        },
        items: [
          "Пополнение криптой или фиатом от 2,5%",
          "Без KYC",
          "0% комиссии по рекламным MCC"
        ],
        cta: "Заказать карту"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "Безлимитная Wild-карта"
        },
        items: [
          "Пополнение криптой или фиатом от 2,5%",
          "Без ограничений по MCC",
          "Apple Pay/Google Pay + пластиковые карты",
          "$100k/мес на ваши транзакции"
        ],
        cta: "Заказать карту"
      }
    }
  },
  investHome: {
    title: "Инвестиционные пулы",
    description:
      "Запуск двух инвестиционных пулов с разными стратегиями — для консервативного и высокодоходного инвестирования.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Пулы трафика",
    description:
      "Участие в NGR от трафика White Rabbit Casino (Казахстан).\n" +
      "Покупаем качественный трафик, конвертим в депозиты, делим прибыль.",
    button: "Следить за обновлениями",
    dashboardTitle: "Инвестиционная панель",
    secondPageDescription1: "Зарабатывайте на GGR с казино-платформ.",
    secondPageDescription2: "Мы покупаем качественный трафик, конвертируем его в депозиты и делимся прибылью.",
    dashboardDescription: "Управляйте инвестициями и отслеживайте результаты по всем пулам.",
    investFirstRowElements: [
      "лет работы", "Reg2Dep", "мес. окупаемость", "от GGR = NGR"
    ],
    poolsTitle: "Текущий набор пулов",
    pools: ["участников", "типа пулов", "месяцев", "ZNX\n" + "общий лимит"],
    poolsOffers: {
      titlesStable: ["Гарантия возврата 100%", "34-42,5% от GGR", "Выплаты в USDC"],
      titlesGrowth: ["Максимальная доходность", "8,5-12,75% от GGR", "Выплаты в USDC"],
      whyHint: {
        safeTitle: "Почему больше % от GGR?",
        safeText: "Мы выкупаем ваши ZNX по текущей стоимости в USD. Процент выше, потому что\nмы покупаем ваши токены и делимся максимальной прибылью. Гарантированный\nвозврат вашей инвестиции в эквиваленте USD сохраняет ваши средства\nв безопасности.",
        growthTitle: "Почему ниже % от GGR?",
        growthText: "В течение 12 месяцев мы управляем вашими токенами ZNX,\nгарантируя, что к концу срока вы получите всю свою инвестицию обратно.\nПроцент ниже, потому что вы сохраняете владение и потенциал роста токена"
      },
      amountStaked: "Вложено средств"
    },
    poolsOffersRow: {
      payoutsStable: ["34% от GGR", "38,25% от GGR", "42,5% от GGR"],
      payoutsGrowth: ["8,5% от GGR", "10.625% от GGR", "12,75% от GGR"]
    },
    poolButton: "Войти в пул",
    nrgComeFrom: {
      title: "Откуда берется NGR для выплат",
      nrgElements: {
        titles: ["GGR от игроков", "Минус 15%", "= NGR", "Участникам пулов"],
        subTitles: ["Валовая игровая выручка", "Административные\n" + "расходы казино", "Чистый игровой доход", "Согласно tier и типу"]
      },
      description: "Пример: GGR $100k → NGR $85k → участники получают от $8.5k до $42.5k в зависимости от пула и tier"
    },
    howItWorks: {
      title: "Как это работает?",
      elements: {
        titles: ["Сбор депозитов", "Закупка трафика", "Генерация прибыли", "Выплаты участникам", "Возврат токенов"],
        descriptions: [
          "Участники депонируют ZNX\n" + "до лимита 230k токенов",
          "Покупаем качественный трафик\n" + "для White Rabbit Casino",
          "Казино зарабатывает GGR\n" + "= \"проигрыш\" - \"выигрыш\" игроков",
          "Ежемесячно % от GGR в USDC\n" + "согласно tier и типу пула",
          "Через 12 месяцев возврат\n" + "согласно выбранному пулу"
        ]
      }
    },
    faq: {
      title: "Часто задаваемые вопросы",
      questions: [
        "Что такое Zenex RevShare Pools?",
        "Как происходят выплаты?",
        "Как рассчитывается мой ежемесячный доход?",
        "Можно ли выйти из пула досрочно?",
        "Что произойдет, если пул не достигнет целевой суммы?",
        "Когда мне вернутся мои ZNX?",
      ],
      answers: [
        "Zenex RevShare Pools — это RWA-токенизация реального казино-бизнеса. Вы приобретаете токены ZNX, размещаете их в пулах привлечения трафика для <span>whiterabbit.casino</span> и получаете фиксированный процент от валового игрового дохода (GGR) каждый месяц в течение 12 месяцев.",
        "Выплаты производятся ежемесячно в USDC 15-го числа каждого месяца в течение 12 месяцев. Средства поступают на ваш баланс в ZNX Hub, после чего их можно сразу вывести или реинвестировать.",
        "Ваш доход зависит от двух факторов: вашей доли в пуле и ежемесячного показателя GGR казино.",
        "Нет, досрочный выход невозможен. Средства заблокированы в смарт-контракте на 12 месяцев. Это позволяет планировать маркетинговые кампании и обеспечивать стабильную доходность.",
        "Пул будет запущен в любом случае. Пропорции распределения прибыли будут определены после осуществления ежемесячных закупок трафика.",
        "100% токенов ZNX, размещённых вами в пуле, будут автоматически возвращены через 12 месяцев.",
      ]
    },
    betshops: {
      title: "Бетшопы"
    },
    questions: {
      title: "Остались вопросы?",
      subtitle: "Свяжитесь с нашей командой прямо сейчас, чтобы подобрать лучший пул для ваших целей!",
      button: "Связаться с нами"
    },
    moreInfo: {
      title: "Больше информации о пулах Zenex RevShare",
      telegram: "Наш Telegram",
      instagram: "Наш Instagram",
      linkedin: "Наш LinkedIn"
    },
    payoutVariations: {
      title: "Как могут различаться выплаты",
      inputLabel: "Введите сумму инвестиций",
      weakLabel: "Слабый сценарий",
      strongLabel: "Сильный сценарий",
      months: [
        "Сегодня",
        "Янв 2025",
        "Апр 2025",
        "Июл 2025",
        "Окт 2025",
        "Янв 2026",
        "Апр 2026",
        "Июл 2026",
        "Окт 2026",
        "Дек 2026"
      ],
      weakScenarioLabel: "Слабый сценарий: итоговая доходность (без роста цены)",
      strongScenarioLabel: "Сильный сценарий: итоговая доходность (рост цены 150%)",
      disclaimer: "Расчеты основаны на исторических данных и не являются прогнозом."
    },
    header: {
      smallTitle: "Пулы RevShare Zenex",
      mainHeading: "Получайте доход от казино без операционных затрат и рисков",
      description: "Мы покупаем качественный трафик для казино, превращаем его в депозиты и делимся прибылью",
      ctaStartEarning: "Начать зарабатывать",
      ctaViewStatistics: "Смотреть статистику",
      stats: {
        item1: {
          value: "60 месяцев",
          description: {
            prefix: "Подтвержденная прибыльность",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Лидирующая в индустрии конверсия рег→деп"
        },
        item3: {
          value: "Прозрачность",
          description: "Отчетность по эффективности и ежемесячные данные"
        },
        item4: {
          value: "Два источника дохода",
          description: "Ежемесячные выплаты в USDC и полный возврат ZNX с потенциалом роста"
        }
      }
    },
    enterToPoolDialog: {
      title: "Баланс ZNX",
      availableBalance: "Доступный баланс",
      stakedInPool: "Застейкано в этом пуле",
      buttonTopUp: "Пополнить баланс",
      buttonEnterPool: "Войти в пул",
      choosePlan: "Выберите план",
      inputLabel: "Введите сумму ZNX",
      inputMessages: {
        exceedsBalance: "Недостаточно средств",
        increase: {
          toIncrease: "Чтобы увеличить ваш",
          addAdditional: "добавьте еще",
          stable: {
            toBasic: "GGR до 34%",
            toAdvanced: "GGR до 38.25%",
            toPremium: "GGR до 42.5%"
          },
          growth: {
            toBasic: "GGR до 8,5%",
            toAdvanced: "GGR до 10.625%",
            toPremium: "GGR до 12.75%"
          }
        }
      }
    },
    myActivePools: {
      title: "Мои активные пулы",
      myActivePoolElements: ["Вклад", "План", "GGR"],
      myActivePoolElementsV2: ["Размер пула", "Вклад", "План", "GGR", "Всего заработано"],
      growUp: "Повысьте план и увеличьте доходность!",
      missing: "Не хватает",
      buttonStats: "Статистика",
      buttonAddZNX: "Добавить ZNX",
      buttonClaim: "Получить",
      months: {
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь"
      },
      status: {
        active: "Активен до {date}",
        prefunding: "Предфинансирование",
        closed: "Закрыт",
      },
      upgrade: {
        label: "Повысьте план до",
        boost: "Увеличьте доход до {percent}% от GGR ({ggr})",
        missing: "Не хватает: ",
      },
    },
    stats: {
      title: "White Rabbit статистика",
      description: "Операционная аналитика казино • Казахстан",
      claimButton: "Получить",
      chartLine: "Динамика GGR",
      barLine: "Динамика активных игроков",
      chartPerios: ["1д", "1н", "1м"],
      addZnx: "Добавить ZNX",
      spent: "Потрачено",
      ftdLabel: "FTD\n(первые депозиты)",
      cpaLabel: "CPA\n(стоимость за FTD)",
      averageDeposit: "Средний депозит",
      ggrThisMonth: "GGR за этот месяц",
      totalGgr: "Суммарный GGR",
      day: "День {day}",
      activity: {
        title: "Статус активности пула",
        status: {
          active: "Активен до {date}",
          prefunding: "Предфинансирование",
          closed: "Закрыт",
          traffic: "Сбор трафика",
        },
      },
      prefunding: {
        goal: "Цель",
        raised: "Собрано",
        investors: "Инвесторы",
        launch: "Старт через"
      },
      stake: {
        label: "Моя доля",
        elements: ["Вклад", "План", "GGR", "Следующий платеж", "Всего заработано"],
      },
      upgrade: {
        label: "Повысьте план до",
        boost: "Увеличьте доход до {percent}% от GGR ({ggr})",
        missing: "Не хватает: ",
      },
      placeholderPool: {
        title: "Статистика появится после запуска пула",
        description: "Инвестируйте сейчас, чтобы первым получить доступ к данным о результатах!",
        action: "Присоединиться к пулу",
      },
      myPayouts: {
        title: "Мои выплаты",
        action: "Получить",
        pool: "{pool} выплата за {month}",
        stable: "Stable Pool",
        growth: "Growth Pool",
        eta: {
          days: "{count, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
          hours: "{count, plural, one {# час} few {# часа} many {# часов} other {# часа}}",
        },
      },
      months: {
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь"
      },
      yourPayouts: "Ваши выплаты за"
    },
    transparency: {
      title: "Детализация",
      lastUpdated: "Обновлено:",
      dataSource: "Источник Данных:",
      crossGamingRevenue: "Валовой игровой доход",
      adminFee: "Административный сбор (15%)",
      netGamingRevenue: "Чистый игровой доход",
      totalDeposits: "Общая сумма депозитов",
      playersCount: "Количество игроков"
    },
    overview: {
      title: "Обзор личных инвестиций",
      totalInvested: "Общая сумма инвестиций",
      totalEarned: "Общий доход",
      nextPayout: "Следующая выплата",
      poolShare: "Ваша доля в пуле:",
      roi: "ROI:",
      paymentDate: "Дата выплаты:",
      poolMetrics: "Метрики пула",
      poolSize: "Размер пула",
      investors: "Инвесторов",
      staked: "Инвестировано",
      players: "Игроков"
    },
    totalStaked: {
      title: "Всего инвестировано",
      button: "Инвестировать в пулы",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "Промо-статистика White Rabbit",
      subtitle: "Смотрите цифры, считайте доход, присоединяйтесь",
      button: "Открыть статистику"
    },
    poolMetrics: {
      title: "Метрики пула",
      metricsElements: ["Размер пула", "Инвесторов", "Инвестировано", "Игроков"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Прогресс пула"
      },
      metrics: {
        ggrShareLabel: "Доля казино GGR",
        lockPeriodLabel: "Период блокировки",
        lockPeriodValue: "12 месяцев",
        payoutsUSDCLabel: "Выплаты в USDC",
        payoutsFrequencyValueMonthly: "Ежемесячно",
        returnedAfterLabel: "Возврат после 12 месяцев",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Ваша доля казино зависит от Тира",
        payoutsDepend: "Выплаты зависят от ежемесячного GGR казино",
        noEarlyWithdrawal: "Досрочный вывод недоступен",
        znxGrowth: "Если ZNX растёт — растёт и ваша итоговая доходность"
      },
      tier: {
        depositLabel: "Депозит:",
        note: "Тир определяется автоматически по сумме депозита"
      },
      button: {
        closed: "Сбор средств закрыт"
      }
    },
    joinPool: "Вступить в пул",
    poolsPromoTitle: "Статистика появится после запуска пула",
    poolsPromoSubtitle: "Инвестируйте сейчас, чтобы первым получить доступ к данным!"
  },
  buy: {
    currency: "Валюта",
    network: "Сеть",
    sum: "Сумма",
    min: "Минимум",
    max: "максимум",
    loading: "Запрос…",
    buy: "Купить",
    approve: "Переведите {amount} {currency} на адрес:"
  },
  claim: {
    have: "У Вас есть",
    available: "токенов",
    description:
      "Нажмите кнопку \"Заклеймить\" и добавьте их к себе на баланс.",
    button: "Заклеймить",
    check: "Проверить",
    total: "Ваш общий счёт",
    tooltip: "Опциональное поле",
    notice: {
      white: "Введите бонусный код, чтобы получить",
      green: "x2 токенов ZNX."
    },
    errors: {
      invalidCode: "Неверный код",
      codeExpired: "Код просрочен",
      codeRequired: "Код обязателен"
    },
    optional: "Необязательное поле"
  },
  page: {
    title: {
      green: "Добро пожаловать в",
      yellow: "Zenex Hub!"
    },
    descriptions1:
      "Спасибо, что верите в нас и хотите развиваться вместе с нами!",
    descriptions2:
      "Мы уже на стадии финального тестирования и скоро представим вам наш функционал.",
    descriptions3: "Успейте получить свои токены",
    descriptions4: "бесплатно",
    descriptions5: "— играйте прямо сейчас!",
    buttons: {
      play: "Играть в Treasure Hunt",
      get: "Забрать ZNX"
    },
    notice: "Данное предложение ограничено во времени.",
    back: "Назад",
    tabs: {
      account: "Аккаунт",
      safety: "Безопасность",
      notifications: "Уведомления",
      referrals: "Рефералы",
      quests: "Квесты"
    }
  },
  balance: {
    title: "Ваши NFT коллекции"
  },
  header: {
    title: {
      profile: "Настройки профиля",
      reshare:"Инвестиции"
    },
    welcome: "Добро пожаловать, {username}!",
    welcome_empty: "Добро пожаловать!",
    button: {
      logout: "Выйти"
    },
    labels: {
      address: "Адрес:",
      caipAddress: "CAIP Адрес:",
      status: "Статус:"
    },
    dropdown: {
      supportChat: "Чат поддержки",
      documents: "Документы",
      legalDocuments: "Юридические документы",
      termsOfUse: "Условия использования",
      privacyPolicy: "Политика конфиденциальности",
      cookiesPolicy: "Политика cookie",
      buyZNXwithCrypto: "ZNX Криптой",
      buyZNXonDEX: "ZNX на DEX",
      buyZNXwithCard: "ZNX картой"
    }
  },
  login: {
    title: {
      green: "Добро пожаловать в",
      white: "Zenex Hub!"
    },
    button: "Подключиться"
  },
  plans: {
    welcome: "Добро пожаловать, {username}!",
    welcome_empty: "Добро пожаловать!",
    title: "Программы инвестиционного доступа Zenex",
    cards: {
      silver: {
        title: "Серебряный уровень",
        subtitle: "Ранний инвестор",
        items: [
          "1 000 мест",
          "ZNX Play: Стейкинг ×1.5 (6 мес.)",
          "ZNX Arena: 5 стандартных карт + 1 золотая",
          "ZNX Invest: Эксклюзивный доступ к пулу",
          "Бонус: 850 ZNX"
        ]
      },
      gold: {
        title: "Золотой уровень",
        subtitle: "Стратегический партнёр",
        items: [
          "200 мест",
          "ZNX Play: Стейкинг ×2 (12 мес.)",
          "ZNX Arena: 8 стандартных карт + 2 золотые",
          "ZNX Invest: +10 % доходности пула",
          "Бонус: 4 200 ZNX"
        ]
      },
      platinum: {
        title: "Платиновый уровень",
        subtitle: "VIP-инвестор",
        items: [
          "50 мест",
          "ZNX Play: Стейкинг ×3 (12 мес.)",
          "ZNX Arena: 10 стандартных карт + 3 золотые",
          "ZNX Invest: +20 % доходности пула",
          "Частный инсайдерский чат",
          "Бонус: 12 500 ZNX"
        ]
      },
      diamond: {
        title: "Бриллиантовый уровень",
        subtitle: "Основатель-партнёр",
        items: [
          "20 мест",
          "ZNX Play: Стейкинг ×4 (12 мес.)",
          "ZNX Arena: 10 стандартных карт + 5 золотых",
          "ZNX Invest: +30 % доходности + гарантированные аллокации",
          "Частный чат + влияние на платформу",
          "Упоминание в Зале славы",
          "Бонус: 12 500 ZNX"
        ]
      }
    },
    button: "Купить",
    available: "Доступные позиции",
    benefits: "Преимущества"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "Держите ZNX — зарабатывайте без усилий"
      },
      invest: {
        title: "ZNX Invest",
        description: "Зарабатывайте с первым iGaming RWA всего за 50 ZNX"
      },
      cases: {
        title: "Кейсы и сундуки",
        description:
          "Открывайте кейсы для случайных наград, бустеров и привилегий."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Прибыль от борьбы промоутеров в бизнес-шоу."
      }
    },
    button: "Скоро",
    buttonOpen: "Перейти"
  },
  meta: {
    title: "Русский"
  },
  cards: {
    transactions: {
      title: 'Последние транзакции',
      column: {
        card: "Карта",
        date: "Дата",
        details: "Детали",
        status: "Статус",
        amount: "Сумма",
        fee: "Комиссия"
      },
      status: {
        RESERVED: "Зарезервировано",
        UNRESERVED: "Разблокировано",
        TRANSFERRED: "Переведено",
        REFUNDED: "Возврат",
        REFUNDED_PARTIAL: "Частичный возврат",
        FAILED: "Ошибка",
        LOADED: "Пополнено",
        UNLOADED: "Списано",
        COMPLETED: "Выполнено"
      }
    },
    myCards: {
      title: "Мои карты",
      goToSite: "Перейти на NS.Cards",
      balance: 'Баланс',
      buyNewCards: "Купить новую карту",
      cardRedirect: "Вы будете перенаправлены на внешний сервис для завершения покупки",
      topUpZnx: "Пополнить через ZNX",
      confirmTopUp: "Подтвердить пополнение",
      topUpAmount: 'Сумма пополнения',
      viewAllCards: 'Показать все карты',
      hideCards: 'Скрыть карты',
      loading: 'Загрузка',
      loadingAddress: 'Загрузка адреса депозита...',
    }
  },
  wallet: {
    title: {
      main: "Кошелек",
      mainNew: "Некастодиальный кошелёк",
      cards: "Zenex Cards",
      balance: "Всего активов",
      transaction: "История транзакций",
      calendar: "Календарь выплат",
      payments: "Ближайшие выплаты"
    },
    availableBalance: "Доступный баланс",
    chooseAssets: "Выберите валюту",
    walletNetworkDeposit: "Сеть",
    walletNetworkWithdraw: "Сеть",
    address: "Адрес",
    destinationAddress: "Адрес назначения",
    enterAddress: "Введите адрес",
    pasteWalletAddress: "Вставьте адрес кошелька",
    enterAmount: "Введите сумму",
    withdrawAmount: "Сумма",
    minimumWithdrawAmount: "Минимальная сумма вывода: {value}",
    transactionDetails: "Детали транзакции",
    transactionFee: "Комиссия транзакции",
    insufficientFundsForFee: "Недостаточно средств для покрытия комиссии транзакции.",
    missing: "Не хватает: {value}",
    addSol: "Добавить SOL",
    paste: "Вставить",
    max: "Макс",
    doubleCheckWithdraw: "Пожалуйста, дважды проверьте адрес!",
    doubleCheckDeposit: "Пожалуйста, дважды проверьте адрес депозита!",
    sendingFundsToWrong: "Отправка средств на неправильный адрес может привести" + "\n" + "к безвозвратной потере вашей криптовалюты.",
    theProcedureUpTo48Hours: "Процедура может занять до 1-2 минут!",
    theProcedureUpTo30min: "Процедура может занять до 30 минут",
    exRate: "Курс обмена",
    swap: "Обменять",
    sell: "Продать",
    receive: "Получить",
    send: "Отправить",
    mainTitle: "Обмен",
    amount: "Сумма",
    toSwap: "Обмен",
    searchTokens: "Искать любой токен",
    selectCurrency: "Выберите валюту",
    selectCurrencyOrNetwork: "Выберите валюту или сеть",
    selectToken: "Выберите токен",
    selectNetwork: "Выберите сеть",
    continueInWallet: "Продолжить в кошельке",
    swapReview: "Пожалуйста, проверьте детали транзакции" + "\n" + "перед подтверждением!",
    depositAddress: "Адрес",
    walletDepositLoading: "Пожалуйста, подождите" + "\n" + " — генерируем ваш депозит-адрес...",
    walletSwapDepositLoading: "Пожалуйста, подождите, инициируется операция обмена...",
    swapPage: {
      youSend: "Вы отправляете",
      youReceive: "Вы получаете",
      swapMinDeposit: "Минимальный депозит",
      fee: "Комиссия",
      feeWithdraw: "Комиссия за вывод",
      finish: "Готово",
      swapSuccess: "Обмен успешно выполнен",
      swapError: "Не удалось выполнить обмен. Попробуйте ещё раз."
    },
    balanceButtons: {
      deposit: "Депозит",
      withdraw: "Вывод",
      exchange: "Обмен",
      buyZNX: "Купить ZNX"
    },
    transactionHistory: {
      type: "Тип",
      total: "Сумма",
      info: "Инфо",
      date: "Дата",
      status: "Статус"
    }
  },
  paymentProcess: {
    awaitingPayment: "Ожидание платежа",
    confirmed: "Подтверждено",
    swapped: "Обмен",
    swapping: "Идёт обмен",
    sending: "Отправка ZNX",
    sendingToken: "Отправка {token}",
    usualTime: "Обычно это занимает 5-30 минут."
  },
  transactionStatus: {
    complete: "Транзакция успешно выполнена!",
    failed: "Что-то пошло не так",
    withdrawFailed: "Вывод не выполнен",
    successSend: "{token} отправлены на ваш кошелек.",
    errorOccurred: "При обработке транзакции возникла ошибка",
    viewOnExplorer: "Открыть в блок-эксплорере",
    contactSupport: "Связаться с поддержкой",
    backToWallet: "Вернуться в кошелёк",
    withdrawComplete: "Вывод выполнен!",
    withdrawAmountLabel: "Сумма вывода",
    destinationAddressLabel: "Адрес назначения",
    estimatedProcessingTimeLabel: "Оценочное время обработки",
    transactionFeeLabel: "Комиссия транзакции",
    continueInWallet: "Продолжить в кошельке",
    checkOnSolscan: "Проверить в Solscan",
    withdrawEtaValue: "{value} минуты",
    withdrawEtaDefault: "1-2 минуты",
    swapComplete: "Обмен завершён!",
    swapFailed: "Обмен не выполнен",
    youSendLabel: "Вы отправляете",
    exchangeRateLabel: "Обменный курс",
    youGetLabel: "Вы получаете"
  },
  play: {
    banner: {
      title: "Staking & Lottery",
      description: "Стейкайте свои токены $ZNX, чтобы получать вознаграждения. Чем дольше ваш стейк, тем выше ваши шансы на победу!"
    },
    statsSmall: {
      previousJackpot: "Предыдущий джекпот",
      upcomingPayment: "Предстоящая выплата",
      activeParticipants: "Активные участники"
    },
    ctaStake: "Застейкать и выиграть",
    chipActive: "Активен",
    stats: {
      totalValueStaked: "Общая сумма стейкинга",
      activeStakers: "Активных стейкеров",
      currentPrizePool: "Текущий призовой фонд"
    },
    nextDraws: {
      title: "Ближайшие розыгрыши",
      description: "Обратный отсчет до следующего розыгрыша призов. Не упустите свой шанс!"
    },
    jackpots: {
      weekly: "Еженедельный джекпот",
      monthly: "Ежемесячный джекпот",
      annual: "Ежегодный джекпот"
    },
    time: {
      days: "Дней",
      hours: "Часов",
      minutes: "Минуты"
    },
    prizeSub: "в призовом фонде",
    stakeDialog: {
      header: "Начать стейкинг",
      description: "Выберите сумму и срок для максимальной потенциальной прибыли",
      labelAmount: "Сумма для стейкинга (ZNX)",
      placeholderAmount: "Введите сумму",
      max: "МАКС",
      infoMessage: "Увеличьте стейк до 500 ZNX, чтобы удвоить потенциальную прибыль!",
      plan: {
        multiplier: "Множитель",
        labelApy: "Фиксированная доходность"
      },
      stats: {
        weeklyDistribution: "Еженедельное распределение",
        monthlyDistribution: "Ежемесячное распределение",
        totalPotentialProfit: "Итого потенциальная прибыль"
      },
      createStake: "Создать стейк"
    },
    summaryRow: {
      stakeAmount: "Сумма стейка",
      duration: "Срок",
      fixedApy: "Фиксированная доходность",
      guaranteedProfit: "Гарантированная прибыль",
      additionalProfitChance: "Дополнительный шанс на прибыль"
    }
  },
  connectDialog: {
    text: "Подключите кошелек, чтобы увидеть все доступные продукты!",
    button: "Подключить кошелек"
  },
  profileCard: {
    hiUser: "Привет, пользователь",
    copyFullAddress: "Скопировать полный адрес",
    profileSettings: "Настройки профиля"
  },
  welcomeDashboard: {
    subTitle: "Вовлекайся. Зарабатывай. Усиливай.",
    description: "Первая iGaming-Fintech экосистема с Casino RWA и революционными решениями!",
    button: "Подключить кошелек",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "пулы",
      description1: "Первый iGaming RWA — финансируйте CPA‑трафик казино и получайте % от выручки платформы (GGR)",
      description2: "участвуя в RevShare‑пулах ZNX для консервативной или высокодоходной стратегии.",
      cta: "Начать зарабатывать"
    },
    dashboardElements: {
      invest: {
        text: "Зарабатывайте каждый месяц на ведущих в отрасли\nпродуктах Casino RWA",
        button: "Зарабатывайте ZNX и USDC"
      },
      play: {
        text: "Держите ZNX, получайте пассивный доход,\nи умножайте его в наших мини‑играх.",
        button: ""
      },
      arena: {
        text: "Зарабатывайте на соперничестве промоутеров за клиентов в первом бизнес‑реалити о казино.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Увеличь свой доход с",
      programName: "Реферальной программой"
    },
    dashboardConnect: {
      subTitle: 'Присоединяйся.\n Зарабатывай. Доминируй',
      text: 'Первая iGaming–Fintech экосистема с токенизированными\n Casino RWA и революционными инвестиционными продуктами.'
    },
    dashboardPartners: {
      title1: "Глобальная сеть.",
      title2: "Единое видение.",
      subTitle: "Интегрировавшись с ведущими партнёрами в сфере iGaming и финтеха, мы используем технологии блокчейна и смарт-контрактов для разработки решений нового поколения."
    },
    dashboardPhotos: {
      title: "Моменты",
      subtitle: "Люди. Энергия. Инновации.",
      followUs: "Следи за нами, чтобы увидеть больше моментов",
      texts: {
        We_brought: "Мы привнесли дух Web3 на MAC Yerevan",
        Innovation_networking: "Инновации, нетворкинг и смелые идеи — это CPA Life Fest с Zenex",
        Zenex_at: "Zenex на BroConf — чистая энергия",
        Connecting_minds: "Соединяя умы на TOKEN2049",
        Game_on: "Игра продолжается на SBC Summit",
        From_insights: "От идей к действиям — на CPA Life Fest",
        TOKEN2049_vibes: "Атмосфера TOKEN2049: рост и энергия",
        Behind_every: "За каждым событием стоит история — о смелых идеях, партнёрстве и незабываемом опыте, который двигает сообщество Zenex вперёд.",
        Bright_ideas: "Светлые идеи, SiGMA"
      }
    }

  }
};
